
<template>
    <section id="dashboard-ecommerce">
      <b-row class="match-height">
        <b-col xl="12" md="12" >
          <b-card
              v-if="array"
              no-body
              class="card-statistics"
            >
            <b-card-body class="statistics-body">
              <b-row>

                <b-col xl="3" sm="6" :class="recebidoEstabelecimento.quantidade.customClass" >
                  <b-media no-body>
                    <b-media-aside  class="mr-2" >
                      <b-avatar  size="48"   :variant="recebidoEstabelecimento.quantidade.color"   >
                        <feather-icon  size="24"  :icon="recebidoEstabelecimento.quantidade.icon"  />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        {{ recebidoEstabelecimento.quantidade.title }}
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ recebidoEstabelecimento.quantidade.subtitle }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>
  
                <b-col xl="3" sm="6" :class="recebidoEstabelecimento.quantidade_paga.customClass" >
                  <b-media no-body>
                    <b-media-aside  class="mr-2" >
                      <b-avatar  size="48"   :variant="recebidoEstabelecimento.quantidade_paga.color"   >
                        <feather-icon  size="24"  :icon="recebidoEstabelecimento.quantidade_paga.icon"  />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        {{ recebidoEstabelecimento.quantidade_paga.title }}
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ recebidoEstabelecimento.quantidade_paga.subtitle }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                <!-- <b-col xl="3" sm="6" :class="recebidoEstabelecimento.total_pago.customClass" >
                  <b-media no-body>
                    <b-media-aside  class="mr-2" >
                      <b-avatar  size="48"   :variant="recebidoEstabelecimento.total_pago.color"   >
                        <feather-icon  size="24"  :icon="recebidoEstabelecimento.total_pago.icon"  />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        {{ "R$ "+ formatPriceR(recebidoEstabelecimento.total_pago.title) }}
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ recebidoEstabelecimento.total_pago.subtitle }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col> -->

                <b-col xl="3" sm="6" :class="recebidoEstabelecimento.total_liquido.customClass" >
                  <b-media no-body>
                    <b-media-aside  class="mr-2" >
                      <b-avatar  size="48"   :variant="recebidoEstabelecimento.total_liquido.color"   >
                        <feather-icon  size="24"  :icon="recebidoEstabelecimento.total_liquido.icon"  />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        {{ "R$ "+ formatPriceR(recebidoEstabelecimento.total_liquido.title) }}
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        Total
                        <!-- {{ recebidoEstabelecimento.total_liquido.subtitle }} -->
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>

                
                

              </b-row>
              
            </b-card-body>
          </b-card>
         
        </b-col>
       
      </b-row>
  
  </section>
    
  </template>
  
  <script>
  import {
    BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
  } from 'bootstrap-vue'
import Excel from './Excel.vue';
  
  export default {
    components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    Excel
},
    props: {
      data: {
        type: Array,
        default: () => [],
      },
    },
  
    data() {
        return {
            statusTab:true,
            array:[
                  {
                    icon: 'TrendingUpIcon',
                    color: 'light-primary',
                    title: '0',
                    subtitle: 'Cobranças emitidas',
                    customClass: 'mb-2 mb-xl-0',
                  },
                  {
                    icon: 'DollarSignIcon',
                    color: 'light-success',
                    title: 'R$ 0,00',
                    subtitle: 'Recebidos',
                    customClass: '',
                  },
                  {
                    icon: 'UserIcon',
                    color: 'light-info',
                    title: '0',
                    subtitle: 'Clientes',
                    customClass: 'mb-2 mb-xl-0',
                  },
                  {
                    icon: 'BoxIcon',
                    color: 'light-danger',
                    title: '1',
                    subtitle: 'Estabelecimentos',
                    customClass: 'mb-2 mb-sm-0',
                  }
                  
                ]
                    
                    
                
        }
    },
    created() {
      this.$store.dispatch("estabelecimentos/saldoEmpresa");
    },
    computed:{
        
        // saldoEmpresa(){
        //          const a ={
        //                 icon: 'DollarSignIcon',
        //                 color: 'light-success',
        //                 title: this.$store.state.estabelecimentos.saldoEmpresa,
        //                 subtitle: 'Saldo Disponivel',
        //                 customClass: ' mt-2 mb-2 mb-xl-0',
        //             }
              
        //     return a
                  
        // },
        recebidoEstabelecimento(){

                let ordens = this.$store.state.estabelecimentos.list_order
                // let total = ordens.reduce((acc, ordem) => parseFloat(acc) + parseFloat(ordem.valorLiquido),0) ;
                let quantidade = ordens.reduce((acc, ordem) => parseFloat(acc) + 1,0) ;
                let quantidade_paga = ordens.reduce((acc, ordem) => ordem.status == 3 ? parseFloat(acc) + 1 : acc, 0);
                let total_pago = ordens.reduce((acc, ordem) => ordem.status == 3 ? parseFloat(acc) + parseFloat(ordem.valor) : acc, 0);
                let total_liquido = ordens.reduce((acc, ordem) => ordem.status == 3 ? parseFloat(acc) + parseFloat(ordem.valorLiquido) : acc, 0);
                
                console.log(quantidade_paga)
                let array = {

                        quantidade: {
                            icon: 'DollarSignIcon',
                            color: 'light-success',
                            title: quantidade,
                            subtitle: 'Cobranças emitidas',
                            customClass: ' mt-2 mb-2 mb-xl-0',
                        },

                        quantidade_paga: {
                            icon: 'DollarSignIcon',
                            color: 'light-primary',
                            title: quantidade_paga,
                            subtitle: 'Cobranças pagas',
                            customClass: ' mt-2 mb-2 mb-xl-0',
                        },
                        total_pago: {
                            icon: 'DollarSignIcon',
                            color: 'light-info',
                            title: total_pago,
                            subtitle: 'Total pago',
                            customClass: ' mt-2 mb-2 mb-xl-0',
                        },
                        total_liquido: {
                            icon: 'DollarSignIcon',
                            color: 'light-success',
                            title: total_liquido,
                            subtitle: 'Total liquido',
                            customClass: ' mt-2 mb-2 mb-xl-0',
                        },


                }
                console.log(array)
            return array
                  
        },
  
        recebidosMes(){
                    
                 const a=   {
                        icon: 'DollarSignIcon',
                        color: 'light-info',
                        title: 'R$ '+ this.$store.state.estabelecimentos.recebidosMes,
                        subtitle: 'Recebidos Mês',
                        customClass: ' mt-2 mb-2 mb-xl-0',
                    }
  
                    return a
                },
        estabelecimento() {
          return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
        },
        usuario() {
          return this.$store.state.login.usuario;
        },
        lista_estabelecimentos() {
          return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
        },
       
    },
    methods:{
          
      formatPriceR(value) {
        
           return value.toLocaleString('pt-br', {minimumFractionDigits: 2});
           
          },
    
    
        }
  }
  </script>
  